module.exports = __webpack_public_path__ + "static/media/travel-live@2x.7c136bf1.png";